import { ButtonBase, Divider } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 4px 12px;
    background: var(--color-back-opacity-10);
    border-radius: 5px;

    h3 {
      font-size: 16px;
    }

    p {
      font-size: 12px;
      font-weight: 500;
    }
  }
`;

export const ComplementItem = styled(ButtonBase)`
  width: 100%;
  gap: 8px;
  padding: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: var(--color-navy-blue);
  font-family: Sora, sans-serif;

  .MuiRadio-colorSecondary.Mui-checked {
    color: var(--color-blue) !important;
  }

  .MuiIconButton-colorSecondary:hover {
    background-color: #329bfc1a;
  }

  .PrivateSwitchBase-root-39 {
    padding: 0;
  }

  .informations {
    display: -webkit-flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
  }

  p {
    font-size: 16px;
    line-height: 20px;
    user-select: none;
    color: var(--color-navy-blue);
    font-family: Sora, sans-serif;
    text-align: start;
  }

  .price {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-alba-grandeza);
    font-family: Sora, sans-serif;
  }
`;

export const CustomDivider = styled(Divider)`
  width: 100%;
  background: var(--color-gray-900);
  height: 2px;
`;

export const Paragraph = styled.p<{ isError?: boolean }>`
  color: ${(p) =>
    p.isError
      ? css`var(--color-red) !important`
      : css`var(--color-green) !important`};
`;
